import React from 'react'

export default class IconsMainNavSubscribers extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M2.476 2.032C2.41604 2.00273 2.34865 1.99221 2.28262 2.0018C2.21659 2.01139 2.15498 2.04066 2.10583 2.08578C2.05668 2.1309 2.02227 2.18979 2.00707 2.25476C1.99188 2.31973 1.99662 2.38777 2.02066 2.45L3.916 7.53467C4.02778 7.83482 4.02778 8.16518 3.916 8.46534L2.02133 13.55C1.9974 13.6122 1.99273 13.6801 2.00792 13.7449C2.0231 13.8098 2.05744 13.8686 2.10648 13.9137C2.15551 13.9587 2.21697 13.988 2.28287 13.9977C2.34877 14.0074 2.41606 13.9971 2.476 13.968L14.476 8.30134C14.5331 8.27434 14.5813 8.23169 14.6151 8.17834C14.6489 8.12499 14.6668 8.06315 14.6668 8C14.6668 7.93686 14.6489 7.87501 14.6151 7.82167C14.5813 7.76832 14.5331 7.72567 14.476 7.69867L2.476 2.032Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4 8H14.6667'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
